/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderStatisticsRespVo } from './OrderStatisticsRespVo';
import {
    OrderStatisticsRespVoFromJSON,
    OrderStatisticsRespVoFromJSONTyped,
    OrderStatisticsRespVoToJSON,
    OrderStatisticsRespVoToJSONTyped,
} from './OrderStatisticsRespVo';

/**
 * 
 * @export
 * @interface ResponseOrderStatisticsRespVo
 */
export interface ResponseOrderStatisticsRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseOrderStatisticsRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseOrderStatisticsRespVo
     */
    message?: string;
    /**
     * 
     * @type {OrderStatisticsRespVo}
     * @memberof ResponseOrderStatisticsRespVo
     */
    data?: OrderStatisticsRespVo;
}

/**
 * Check if a given object implements the ResponseOrderStatisticsRespVo interface.
 */
export function instanceOfResponseOrderStatisticsRespVo(value: object): value is ResponseOrderStatisticsRespVo {
    return true;
}

export function ResponseOrderStatisticsRespVoFromJSON(json: any): ResponseOrderStatisticsRespVo {
    return ResponseOrderStatisticsRespVoFromJSONTyped(json, false);
}

export function ResponseOrderStatisticsRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseOrderStatisticsRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : OrderStatisticsRespVoFromJSON(json['data']),
    };
}

export function ResponseOrderStatisticsRespVoToJSON(json: any): ResponseOrderStatisticsRespVo {
    return ResponseOrderStatisticsRespVoToJSONTyped(json, false);
}

export function ResponseOrderStatisticsRespVoToJSONTyped(value?: ResponseOrderStatisticsRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': OrderStatisticsRespVoToJSON(value['data']),
    };
}

